import {Grid} from '@material-ui/core';
import {Check} from 'Agent/Claims/models/Check';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';

type CheckPaymentProps = {
  check: Check;
};

const CheckPayment = (props: CheckPaymentProps) => {
  const {check} = props;

  return (
    <Grid container direction="column" wrap="nowrap" className="check">
      <CardField name="Issue Date" value={toFormattedDateAsUTC(check.issueDate)} />
      <CardField name="Clear Date" value={toFormattedDateAsUTC(check.clearDate)} />
      <CardField name="Payment Type" value={check.paymentType} />
    </Grid>
  );
};

export default CheckPayment;
